import React from "react";
import { Div, Button } from "glamorous";
import PropTypes from "prop-types";
import styles from "../../styles";
import data from "../../data";
import router from "../../misc/router";
import jwLogoSm from "../../imgs/jw-logo-sm.png";
import { CloseButton, UndoButton } from "./Header/Buttons";
import { ExperienceConsumer } from "../../providers/ExperienceContext";

const getRightButton = (area, context, loadProductSelectorArea, resetLabel, referrer, handleLogoClick) => {
  if (/Editor/.test(area) ) {
    return <UndoButton handleReset={resetLabel}/>
  }

  if (context.isEmbedded) {
    // embedded mode, close is a noop
    return null;
  }

  if (context.method === 'redirect' && referrer) {
    // in redirect mode, we return to the referrer (if we have it!)
    return <CloseButton handleClose={handleLogoClick}/>
  }

  if (context.isInStore && area !== 'ProductSelector') {
    return <CloseButton handleClose={loadProductSelectorArea} />
  }

  return null;
};

const Header = ({ showBackButton, handleBack, handlePlay, handleLogoClick, area, loadProductSelectorArea, resetLabel, referrer }) => (
  <ExperienceConsumer>
    {(context) => (
      <Div css={styles.header.wrapper(area)}>
        <Div css={styles.header.container}>
          {router.showVideo() ? (
            <Button onClick={handlePlay} css={styles.header.play}>
              {data.copy("headerVideoBtn")}
            </Button>
            ) :
            showBackButton ? <Button onClick={handleBack} css={styles.header.back} /> : <div>&nbsp;</div>
          }
          <Div css={styles.header.logo(area)}>
            <img
            src={jwLogoSm}
            alt="Johnnie Walker"
            onClick={handleLogoClick}
            />
          </Div>
          {getRightButton(area, context, loadProductSelectorArea, resetLabel, referrer, handleLogoClick) || <div>&nbsp;</div>}
        </Div>
      </Div>
    )}
  </ExperienceConsumer>
);

Header.propTypes = {
  handleBack: PropTypes.func.isRequired,
  handlePlay: PropTypes.func.isRequired,
  area: PropTypes.string.isRequired,
  handleLogoClick: PropTypes.func,
  showBackButton: PropTypes.bool,
  referrer: PropTypes.string
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/common/Header.js